import { render, staticRenderFns } from "./CadastroUsuario.vue?vue&type=template&id=32b97868&scoped=true&"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuario.vue?vue&type=style&index=0&id=32b97868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b97868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable})
